/** Platforms available in dashboard select; `icon` is the Lucide dynamic icon name. */
export const FOOTER_SOCIAL_PLATFORMS = [
  { value: 'linkedin', label: 'LinkedIn', icon: 'linkedin' },
  { value: 'facebook', label: 'Facebook', icon: 'facebook' },
  { value: 'instagram', label: 'Instagram', icon: 'instagram' },
  { value: 'twitter', label: 'Twitter', icon: 'twitter' },
  { value: 'x', label: 'X', icon: 'twitter' },
  { value: 'youtube', label: 'YouTube', icon: 'youtube' },
  { value: 'github', label: 'GitHub', icon: 'github' },
  { value: 'discord', label: 'Discord', icon: 'message-circle' },
  { value: 'threads', label: 'Threads', icon: 'at-sign' },
  { value: 'tiktok', label: 'TikTok', icon: 'music-2' },
  { value: 'whatsapp', label: 'WhatsApp', icon: 'message-circle' },
];

export function lucideIconForFooterPlatform(platform) {
  const key = String(platform || '').trim().toLowerCase();
  const found = FOOTER_SOCIAL_PLATFORMS.find((p) => p.value === key);
  return found?.icon || 'link';
}
